export const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const hours = d.getHours().toString().padStart(2, "0");
  const minutes = d.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const getDaysInMonth = (year, month) => {
  const date = new Date(year, month, 1);
  const days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return days;
};

// [新增] 計算年資 (到職日 -> 指定日期)
export const calculateTenure = (startDateStr, targetDate = new Date()) => {
  if (!startDateStr) return "未設定";
  const start = new Date(startDateStr);
  const end = new Date(targetDate);

  if (isNaN(start.getTime())) return "格式錯誤";

  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }

  // 如果未滿一個月不顯示 0個月，或者顯示 "未滿月"
  if (years === 0 && months === 0) return "未滿 1 個月";

  let result = "";
  if (years > 0) result += `${years} 年 `;
  if (months > 0) result += `${months} 個月`;

  return result || "未滿 1 個月";
};
